import classNames from "classnames";

import { FC, Fragment } from "react";
import useI18n from "../../../hooks/useTranslations";
import { VertigripNormativeForSettings } from "../../../http/vertigrip/types/vertigripSettings";
import { getMinutesRoundedTimestamp } from "../../../utils";
import ImageBorderBox from "../../ui/BorderBox";
import ModalDialog from "../../ui/ModalDialog";
import styles from "./VertigripNormativesHelpModal.module.css";

type VertigripNormativesHelpModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSelect?: (item: VertigripNormativeForSettings) => void;
  items: VertigripNormativeForSettings[];
};

export const VertigripNormativesHelpModal: FC<VertigripNormativesHelpModalProps> = ({
  items,
  isOpen,
  onClose,
  onSelect,
}: VertigripNormativesHelpModalProps) => {
  const i18n = useI18n();

  return (
    <>
      {isOpen && (
        <ModalDialog
          title={i18n.translation.normatives.plural}
          isSubmitting={false}
          onClose={onClose}
          actions={[{ title: i18n.translation.common.close, onClick: onClose }]}
        >
          <div
            className={classNames(styles.grid, {
              [styles.grid1]: items.length === 1,
              [styles.grid2]: items.length > 1,
            })}
          >
            {items.map((item) => (
              <Fragment key={item.id}>
                <ImageBorderBox
                  onClick={onSelect ? () => onSelect(item) : undefined}
                  showIsMissing={true}
                  title={item.name}
                  description={item.description}
                >
                  <div className={styles.img}>
                    {item.image ? (
                      <ImageBorderBox.Image
                        src={`${import.meta.env.VITE_BUCKET_URL}${item.image}?${getMinutesRoundedTimestamp()}`}
                      />
                    ) : (
                      ImageBorderBox.PlaceHolder
                    )}
                  </div>
                </ImageBorderBox>
              </Fragment>
            ))}
          </div>
        </ModalDialog>
      )}
    </>
  );
};
